import React from 'react';
import { textHelpers } from 'components/hintTypes/helpers';
import { Intent } from 'constants/ui';
import BaseHint from '../BaseHint';
import {} from './EmailAlreadyInvitedHint.types';
import { EmailAlreadyInvitedHintText } from './EmailAlreadyInvitedHintText';
const EmailAlreadyInvitedHint = ({ member, onNavigate }) => (React.createElement(BaseHint, { intent: Intent.DANGER, multiline: true, text: React.createElement(EmailAlreadyInvitedHintText, { onNavigate: onNavigate }), title: textHelpers.getEmailAlreadyInvitedHintTitle(member) }));
export default EmailAlreadyInvitedHint;
